import {v4 as uuid} from 'uuid';

export function create(questionId, value, createdDate) {
  return {
    id: uuid(),
    value,
    questionId,
    createdDate
  }
}